import labelmake from "labelmake";
import { Template } from "labelmake/dist/types/type";
import { RegistrationAdminInfo } from "../../../models";
import moment from "moment-timezone";
import { parseRegistrationTypeString } from "../../../utils/Utils";

export const CreatePDF = async (a: RegistrationAdminInfo, n: number) => {
    const template = {
        basePdf:
            "data:application/pdf;base64,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",
        schemas: [
            {
                AthleteName: {
                    type: "text",
                    position: {
                        x: 17.61,
                        y: 86.00,
                    },
                    width: 163.23,
                    height: 15,
                    alignment: "left",
                    fontSize: 30,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                ITATitle: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 55.04,
                    },
                    width: 155.38,
                    height: 10.96,
                    alignment: "left",
                    fontSize: 14,
                    characterSpacing: 1,
                    lineHeight: 2,
                },
                ITALogoImage: {
                    type: "image",
                    position: {
                        x: 81.43,
                        y: 17.17,
                    },
                    width: 48.69,
                    height: 17.5,
                },
                RegistrationCountLabel: {
                    type: "text",
                    position: {
                        x: 19,
                        y: 260.00,
                    },
                    width: 124.16,
                    height: 6.73,
                    alignment: "left",
                    fontSize: 14,
                    characterSpacing: 1,
                    lineHeight: 1,
                },
                DateLabel: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 68.79,
                    },
                    width: 19.65,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                DateValue: {
                    type: "text",
                    position: {
                        x: 38.1,
                        y: 68.79,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                TimeLabel: {
                    type: "text",
                    position: {
                        x: 17.72,
                        y: 77.23,
                    },
                    width: 19.65,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                TimeValue: {
                    type: "text",
                    position: {
                        x: 38.09,
                        y: 77.23,
                    },
                    width: 56.43,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                "Accreditation label:": {
                    type: "text",
                    position: {
                        x: 17.46,
                        y: 110.56,
                    },
                    width: 52.46,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                AccreditationValue: {
                    type: "text",
                    position: {
                        x: 73.02,
                        y: 110.51,
                    },
                    width: 57.75,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CountryLabel: {
                    type: "text",
                    position: {
                        x: 17.46,
                        y: 120.09,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CountryValue: {
                    type: "text",
                    position: {
                        x: 73.29,
                        y: 120.3,
                    },
                    width: 57.48,
                    height: 6.99,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                GenderLabel: {
                    type: "text",
                    position: {
                        x: 17.46,
                        y: 129.88,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                GenderValue: {
                    type: "text",
                    position: {
                        x: 73.28,
                        y: 130.08,
                    },
                    width: 57.75,
                    height: 6.99,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                DisciplineLabel: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 138.87,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                DisciplineValue: {
                    type: "text",
                    position: {
                        x: 73.03,
                        y: 138.61,
                    },
                    width: 58.02,
                    height: 6.99,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                RegistrationCountValue: {
                    type: "text",
                    position: {
                        x: 145.79,
                        y: 260,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 14,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                AddressFooter: {
                    type: "text",
                    position: {
                        x: 46.96,
                        y: 278.05,
                    },
                    width: 122.31,
                    height: 6.99,
                    alignment: "left",
                    fontSize: 9,
                    characterSpacing: 0,
                    lineHeight: 1,
                    fontColor: "#666666",
                },
                field19: {
                    type: "text",
                    position: {
                        x: 55.03,
                        y: 285.65,
                    },
                    width: 103.52,
                    height: 7,
                    alignment: "left",
                    fontSize: 9,
                    characterSpacing: 0,
                    lineHeight: 1,
                    fontColor: "#666666",
                },
                RegistrationIDLabel: {
                    type: "text",
                    position: {
                        x: 19,
                        y: 250,
                    },
                    width: 123.62,
                    height: 7.79,
                    alignment: "left",
                    fontSize: 14,
                    characterSpacing: 1,
                    lineHeight: 1,
                },
                RegistrationTypeLabel: {
                    type: "text",
                    position: {
                        x: 17.72,
                        y: 148.4,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                FromDateLabel: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 157.45,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                ToDateLabel: {
                    type: "text",
                    position: {
                        x: 17.99,
                        y: 166.92,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CityLabel: {
                    type: "text",
                    position: {
                        x: 17.99,
                        y: 176.44,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                AddressLabel: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 185.97,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                PostalCodeLabel: {
                    type: "text",
                    position: {
                        x: 17.73,
                        y: 194.7,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                BuildingNameLabel: {
                    type: "text",
                    position: {
                        x: 17.99,
                        y: 203.7,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                FloorLabel: {
                    type: "text",
                    position: {
                        x: 17.99,
                        y: 212.16,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                RoomLabel: {
                    type: "text",
                    position: {
                        x: 18,
                        y: 220.63,
                    },
                    width: 35,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                RegistrationTypeValue: {
                    type: "text",
                    position: {
                        x: 73.03,
                        y: 147.61,
                    },
                    width: 57.49,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                FromDateValue: {
                    type: "text",
                    position: {
                        x: 72.5,
                        y: 156.86,
                    },
                    width: 58.02,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                ToDateValue: {
                    type: "text",
                    position: {
                        x: 72.75,
                        y: 165.86,
                    },
                    width: 58.02,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CityValue: {
                    type: "text",
                    position: {
                        x: 72.23,
                        y: 176.18,
                    },
                    width: 58.28,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                AddressValue: {
                    type: "text",
                    position: {
                        x: 72.23,
                        y: 185.7,
                    },
                    width: 58.28,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                PostalCodeValue: {
                    type: "text",
                    position: {
                        x: 72.23,
                        y: 194.7,
                    },
                    width: 58.55,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                BuildingNameValue: {
                    type: "text",
                    position: {
                        x: 71.97,
                        y: 203.44,
                    },
                    width: 58.54,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                FloorValue: {
                    type: "text",
                    position: {
                        x: 71.7,
                        y: 212.43,
                    },
                    width: 59.08,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                RoomNumberValue: {
                    type: "text",
                    position: {
                        x: 71.7,
                        y: 220.89,
                    },
                    width: 59.34,
                    height: 7,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                RegistarationIDValue: {
                    type: "text",
                    position: {
                        x: 145.52,
                        y: 250,
                    },
                    width: 35,
                    height: 7.79,
                    alignment: "left",
                    fontSize: 14,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CommentsLabel: {
                    type: "text",
                    position: {
                        x: 18,
                        y: 230,
                    },
                    width: 35,
                    height: 7.79,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
                CommentsValue: {
                    type: "text",
                    position: {
                        x: 71,
                        y: 230,
                    },
                    width: 100,
                    height: 16,
                    alignment: "left",
                    fontSize: 12,
                    characterSpacing: 0,
                    lineHeight: 1,
                },
            },
        ],
    } as Template;

    const inputs = [
        {
            AthleteName: a.name!,
            ITATitle: "ITA Rooming Application registration extract:\n",
            ITALogoImage:
                "data:image/png;base64,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",
            RegistrationCountLabel:
                "Total number of registration for this athlete: ",
            DateLabel: "Date:",
            DateValue: moment().tz("Asia/Tokyo").format("MM/DD/YYYY"),
            TimeLabel: "Time:",
            TimeValue:
                moment().tz("Asia/Tokyo").format("HH:mm") +
                " Japan Standard Time",
            "Accreditation label:": "Accreditation number:",
            AccreditationValue: a.accreditationNumber!,
            CountryLabel: "Country:",
            CountryValue: a.country!,
            GenderLabel: "Gender:",
            GenderValue: a.gender!,
            DisciplineLabel: "Sport / Discipline:",
            DisciplineValue: a.sport  + " / " + a.discipline,
            RegistrationCountValue: n.toString(),
            AddressFooter:
                "International Testing Agency, Avenue de Rhodanie 58, 1007 Lausanne, Switzerland\n",
            field19:
                "Phone: +41 (0)21 612 12 12 | Email: info@ita.sport | Web: www.ita.sport",
            RegistrationIDLabel:
                "Internal registration identifier / Registration ID: ",
            RegistrationTypeLabel: "Registration Type:",
            FromDateLabel: "From date:",
            ToDateLabel: "To date:",
            CityLabel: "City:",
            AddressLabel: "Address:",
            PostalCodeLabel: "Postal code:",
            BuildingNameLabel: "Building name:",
            FloorLabel: "Floor:",
            RoomLabel: "Room number:",
            RegistrationTypeValue: parseRegistrationTypeString(a.registrationType!),
            FromDateValue: a.fromDate!,
            ToDateValue: a.toDate!,
            CityValue: a.city!,
            AddressValue: a.address!,
            PostalCodeValue: a.postalCode!,
            BuildingNameValue: a.buildingName!,
            FloorValue: a.floor!,
            RoomNumberValue: a.room!,
			RegistarationIDValue: a.registrationID!,
            CommentsLabel: "Comments:",
            CommentsValue: a.comments??""
        },
    ];

    const pdf = await labelmake({ template, inputs });
    const blob = new Blob([pdf.buffer], { type: "application/pdf" });

    let fileName =
        a.accreditationNumber! +
        "-" +
        moment().tz("Asia/Tokyo").format("DDMMYYYY") +
        ".pdf";

    const anchor = window.document.createElement("a");
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(anchor.href);
};
